import { Modal } from "antd";
import React from "react";
import ClientCaptcha from "react-client-captcha";
import ErrorPage from "../Notification/Error";

function Search({ props }) {
  const {
    isTrack,
    loadTrack,
    onCancel,
    onSearch,
    onChangeTrack,
    dataTrack,
    setCaptcha,
    isError,
  } = props;

  return (
    <Modal
      title={null}
      visible={isTrack}
      onOk={null}
      onCancel={null}
      footer={null}
      closable={false}
      keyboard={false}
      width={400}
    >
      <div>
        <p className="header-title-bold colors-blue text-2xl mb-3 font-bold">
          Lacak Pemeriksaan
        </p>

        {/* Content Section */}
        <div className="mt-8">
          <div name="no-invoice-form" className="mb-6">
            <p className="login-title-form mb-3 text-lg lg:text-xl">
              Nomor Invoice
            </p>
            <input
              disabled={loadTrack}
              onChange={(e) => onChangeTrack(e)}
              name="invoice"
              value={dataTrack.invoice}
              className={`${
                loadTrack ? "input-disabled" : "form-input"
              } outline-none w-full p-3`}
              placeholder="Masukkan nomor invoice"
            />
            {isError
              ? isError.length > 0
                ? isError
                    .filter((it) => it.type === "invoice")
                    .map((its, idx) => (
                      <ErrorPage
                        key={idx}
                        props={{ idx, message: its.message }}
                      />
                    ))
                : null
              : null}
          </div>

          <div name="no-hp-form" className="mb-6">
            <p className="login-title-form mb-3 text-lg lg:text-xl">
              Nomor Handphone
            </p>
            <input
              disabled={loadTrack}
              onChange={(e) => onChangeTrack(e)}
              name="no_hp"
              maxLength={13}
              pattern="[0-9]*"
              value={dataTrack.no_hp === 0 ? undefined : dataTrack.no_hp}
              type="text"
              className={`${
                loadTrack ? "input-disabled" : "form-input"
              } outline-none w-full p-3`}
              placeholder="Masukkan nomor handphone"
            />
            {isError
              ? isError.length > 0
                ? isError
                    .filter((it) => it.type === "no_hp")
                    .map((its, idx) => (
                      <ErrorPage
                        key={idx}
                        props={{ idx, message: its.message }}
                      />
                    ))
                : null
              : null}
          </div>

          <div name="captcha-form" className="mb-6">
            <p className="login-title-form mb-3 text-lg lg:text-xl">Captcha</p>
            <div className="flex items-center w-full">
              <div className="w-1/2">
                <ClientCaptcha captchaCode={(code) => setCaptcha(code)} />
              </div>
              <input
                disabled={loadTrack}
                onChange={(e) => onChangeTrack(e)}
                name="captcha"
                value={dataTrack.captcha}
                className={`${
                  loadTrack ? "input-disabled" : "form-input"
                } outline-none w-2/3 p-3`}
                placeholder="Masukkan Chapta"
              />
            </div>
            {isError
              ? isError.length > 0
                ? isError
                    .filter((it) => it.type === "captcha")
                    .map((its, idx) => (
                      <ErrorPage
                        key={idx}
                        props={{ idx, message: its.message }}
                      />
                    ))
                : null
              : null}
          </div>
        </div>
        <div>
          <button
            disabled={loadTrack}
            onClick={onSearch}
            className={`${
              loadTrack ? "btn-loading" : "btn-blue"
            }  w-full p-3 mt-8 focus:outline-none`}
          >
            <p className="text-white lg:text-lg">
              {loadTrack ? "Loading" : "Track Pemeriksaan"}
            </p>
          </button>
          <p
            onClick={onCancel}
            disabled={loadTrack}
            className="text-center mt-5 cursor-pointer colors-gray font-semibold text-base"
          >
            Batal
          </p>
        </div>
      </div>
    </Modal>
  );
}

export default Search;
